import { useMutation } from '@tanstack/react-query'
import ConfirmableSpinnableButton from 'app/components/buttons/ConfirmableSpinnable'
import createModelMember from 'braindamage/api/createModelMember'
import Dodone from 'models/dodone'

export default ({ dodoableId, text = 'Bora' }) => {
  const [dodone, setDodone] = useState()

  const createDodone = useMutation({
    mutationFn: async ({ attributes }) => {
      return createModelMember(`/api/dodones`, Dodone, {
        ['dodoneAttributes']: attributes
      })
    },
    onSuccess: async (data) => {
      setDodone(data.dodone)
      // queryClient.setQueryData(['dodone', dodone.id], data)
    },
    onSettled: async (data) => {
      // console.log("onSettled", data);
    },
    onError: async (data) => {
      console.log('onError', data)
    }
  })

  const onCreateDodone = useCallback(() => {
    createDodone.mutate({
      attributes: { dodoableId, startedAt: new Date(), origin: 'free' }
    })
  })

  if (dodone) return <Navigate to={`/dodones/${dodone.id}`} replace />

  return (
    <div className="input-group">
      <ConfirmableSpinnableButton
        className="btn btn-primary btn-block"
        onConfirm={onCreateDodone}
        isSpinning={createDodone.isPending}
        confirmation="Bora?"
      >
        {text}
      </ConfirmableSpinnableButton>
    </div>
  )
}
